import { render } from "./HomeFooter.vue?vue&type=template&id=528f739a&scoped=true&ts=true"
import script from "./HomeFooter.vue?vue&type=script&lang=ts"
export * from "./HomeFooter.vue?vue&type=script&lang=ts"

import "./HomeFooter.vue?vue&type=style&index=0&id=528f739a&scoped=true&lang=less"

import exportComponent from "/builds/fe/keyan-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528f739a"]])

export default __exports__